import { useQuery } from '@tanstack/react-query';
import { productsAPI } from '../services/api';

export const useAutocomplete = (query) => {
  return useQuery({
    queryKey: ['autocomplete', query],
    queryFn: () => productsAPI.autocomplete(query),
    enabled: query.length >= 2,
    staleTime: 1000 * 60 * 2,
    placeholderData: (prev) => prev,
  });
};
